<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <van-cell
        class="mt10"
        size="large"
        :icon="`./static/icon/${Theme}/icon-info1.png`" 
        :title="$t('userInfo.default[1]')"
        center
        is-link
        @click="showHeader=true"
      >
        <img :src="`./static/head/${UserInfo.header}`" height="56" style="border:2px #e6e5e8 solid;border-radius: 100%;">
      </van-cell>
      <van-cell 
        size="large"
        :icon="`./static/icon/${Theme}/icon-info2.png`"
        :title="$t('userInfo.default[2]')"
        center
        :value="UserInfo.phone?UserInfo.phone:$t('UserInfo[0][1]')"
        to="set/phone"
        is-link
      />
      <van-cell 
        size="large"
        :icon="`./static/icon/${Theme}/icon-mail.png`"
        :title="$t('UserInfo[0][0]')"
        center
        :value="UserInfo.mail?UserInfo.mail:$t('UserInfo[0][1]')"
        to="set/mail"
        is-link
      />
      <van-cell
        v-if="InitData.setting.is_telegram==1" 
        size="large"
        :icon="`./static/icon/${Theme}/icon-telegram.png`"
        :title="$t('UserInfo[6][0]')"
        center
        :value="$t('UserInfo[6][1]')"
        to="/article/telegram/0"
        is-link
      />
      <van-cell 
        size="large"
        :icon="`./static/icon/${Theme}/icon-info3.png`"
        :title="$t('userInfo.default[3]')"
        center
        :value="$t('userInfo.default[8]')"
        to="bankCard"
        is-link
      />
      <van-cell
        v-if="InitData.setting.usdt_withdrawal==1"
        size="large"
        :icon="`./static/icon/${Theme}/icon-info3.png`"
        :title="$t('userInfo.default[14]')"
        center
        :value="$t('userInfo.default[8]')"
        to="set/usdt"
        is-link
      />
      <van-cell 
        size="large"
        :icon="`./static/icon/${Theme}/icon-info4.png`"
        :title="$t('userInfo.default[5]')"
        center
        :value="$t('userInfo.default[8]')"
        to="set/realname"
        is-link
      />
      <van-cell
        v-if="InitData.setting.is_address==1"
        size="large"
        :icon="`./static/icon/${Theme}/icon-info9.png`"
        :title="$t('userInfo.default[16]')"
        center
        :value="$t('userInfo.default[8]')"
        to="set/address"
        is-link
      />
      <van-cell
        class="mt10"
        size="large"
        :icon="`./static/icon/${Theme}/icon-info5.png`"
        :title="$t('userInfo.default[6]')"
        center
        :value="$t('userInfo.default[8]')"
        is-link
        @click="showPassWord=true"
      />
      <van-cell 
        size="large"
        :icon="`./static/icon/${Theme}/icon-info6.png`"
        :title="$t('userInfo.default[7]')"
        center
        :value="$t('userInfo.default[8]')"
        is-link
        @click="showPayWord=true"
      />
      <van-cell
        v-if="wsUrl"
        class="mt10"
        size="large"
        :icon="`./static/icon/${Theme}/icon-info8.png`"
        :title="$t('userInfo.default[15]')"
        center
      >
        <template #right-icon>
          <van-switch v-model="checkedPush" size="24" active-color="var(--color-active)" @change="changePush" />
        </template>
      </van-cell>
      <van-cell
        size="large"
        :icon="`./static/icon/${Theme}/icon-info7.png`"
        :title="$t('userInfo.default[13]')"
        center
        is-link
        @click="clearCache"
      />
    </div>
    <van-action-sheet v-model="showHeader" :title="$t('userInfo.default[9]')" close-on-popstate>
      <van-form ref="setHeader" @submit="setUserInfo">
        <van-field v-show="false" :value="radioHeader" name="header" readonly />
      </van-form>
      <van-grid clickable icon-size="45" column-num="5">
        <van-grid-item v-for="item in 10" :key="item" :icon="`./static/head/head_${item}.png`" @click="selectHeader(item)" />
      </van-grid>
    </van-action-sheet>
    <van-action-sheet v-model="showPassWord" :title="$t('userInfo.default[10]')"close-on-popstate>
      <van-form v-if="showPassWord" @submit="setUserInfo">
        <input type="password" style="position: absolute;opacity: 0;z-index: -1">
        <van-field 
          v-model.trim="postData.o_password" 
          name="o_password" 
          type="password" 
          :label="$t('userInfo.label[0]')" 
          :placeholder="$t('userInfo.placeholder[0]')" 
          clearable 
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('userInfo.placeholder[0]') }]"
        />
        <van-field 
          v-model.trim="postData.n_password" 
          name="n_password" 
          type="password" 
          :label="$t('userInfo.label[1]')" 
          :placeholder="$t('userInfo.placeholder[1]')" 
          clearable 
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('userInfo.placeholder[1]') }]"
        />
        <van-field 
          v-model.trim="postData.r_password" 
          name="r_password" 
          type="password" 
          :label="$t('userInfo.label[2]')" 
          :placeholder="$t('userInfo.placeholder[2]')" 
          clearable 
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('userInfo.placeholder[2]') }]"
        />
        <div style="padding: 16px;">
          <van-button type="danger" block round style="font-size: 16px">{{$t('userInfo.default[12]')}}</van-button>
        </div>
      </van-form>
    </van-action-sheet>
    <van-action-sheet v-model="showPayWord" :title="$t('userInfo.default[11]')" close-on-popstate @closed="forgetPayword=false,postData={}">
      <van-form v-if="showPayWord" @submit="setUserInfo">
        <input type="password" style="position: absolute;opacity: 0;z-index: -1">
        <van-field 
          v-if="UserInfo.is_fund_password==1&&!forgetPayword" 
          v-model.trim="postData.o_payword"
          name="o_payword"
          type="password" 
          :label="$t('userInfo.label[3]')" 
          :placeholder="$t('userInfo.placeholder[3]')" 
          clearable 
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('userInfo.placeholder[3]') }]"
          key="o_payword"
        />
        <van-field 
          v-model.trim="postData.n_payword"
          name="n_payword"
          type="password" 
          :label="$t('userInfo.label[4]')" 
          :placeholder="$t('userInfo.placeholder[4]')" 
          clearable 
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('userInfo.placeholder[4]') }]"
          key="n_payword"
        />
        <van-field 
          v-model.trim="postData.r_payword"
          name="r_payword"
          type="password" 
          :label="$t('userInfo.label[5]')" 
          :placeholder="$t('userInfo.placeholder[5]')" 
          clearable 
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('userInfo.placeholder[5]') }]"
          key="r_payword"
        />
        <!-- <van-field
          v-if="forgetPayword" 
          v-model.trim="postData.code"
          name="code"
          type="digit"
          :label="$t('userInfo.label[8]')"
          :placeholder="$t('register.placeholder[6]')"
          clearable
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('register.placeholder[6]') }]"
          key="code"
        >
          <template #button>
            <van-image width="100" height="34" :src="codeImg" style="display: block;cursor: pointer;" @click="getCode" />
          </template>
        </van-field> -->
        <van-field 
          v-if="forgetPayword" 
          v-model.trim="postData.smscode"
          name="smscode"
          type="digit" 
          :label="$t('userInfo.label[8]')"
          :placeholder="$t('register.placeholder[6]')"
          clearable 
          size="large"
          autocomplete="off"
          :rules="[{ required: true, message: $t('register.placeholder[6]') }]"
          key="smscode"
        >
          <div slot="button" style="display:flex;flex-direction:column">
            <van-button v-if="InitData.setting.is_sms==1" size="mini" type="info" round :color="isSendCode?'var(--color-assist)':''" native-type="button" :disabled="isSendCode" style="margin-bottom: 6px" @click="postData.type='phone',getSmsCode()">{{$t('register.text[2]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>
            <van-button v-if="InitData.setting.is_mail==1" size="mini" type="info" round :color="isSendCode?'var(--color-assist)':''" native-type="button" :disabled="isSendCode" style="margin:0" @click="postData.type='mail',getMailCode()">{{$t('Register[1][1]')}}{{isSendCode?`(${sendTime}s)`:''}}</van-button>
          </div>
        </van-field>
        <van-field
          v-if="forgetPayword"
          v-show="false"
          :value="postData.type"
          name="type"
        />
        <div v-if="(InitData.setting.is_sms==1||InitData.setting.is_mail==1)&&UserInfo.is_fund_password==1&&!forgetPayword" style="padding: 10px 20px 0;text-align: right;">
          <a href="javascript:;" style="color:var(--color-active);text-decoration: underline;" @click="forgetPayword=true">{{$t('userInfo.label[6]')}}</a>
        </div>
        <div style="padding: 16px;">
          <van-button type="danger" block round style="font-size: 16px">{{$t('userInfo.default[12]')}}</van-button>
        </div>
      </van-form>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'Info',
  components: {
  },
  props: [],
  data() {
    return {
      showHeader: false,
      showPassWord: false,
      showPayWord: false,
      radioHeader: '',
      postData: {
        o_password:'',
        n_password:'',
        r_password:'',
        o_payword:'',
        n_payword:'',
        r_payword:'',
        type: 'phone',
        smscode: ''
      },
      checkedPush: !Boolean(localStorage['PushState']),
      wsUrl: WsUrl,
      forgetPayword: false,
      codeImg: '',
      isSendCode: false,
      downTimer: null,
      sendTime: 60,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$parent.navBarTitle = this.$t('userInfo.default[0]')
    this.$Model.GetUserInfo()
    // this.getCode()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    clearInterval(this.downTimer)
  },
  methods: {
    countDown() {
      this.downTimer = setInterval(()=>{
        this.sendTime --
        if(this.sendTime<0){
          this.isSendCode = false
          this.sendTime = 60
          clearInterval(this.downTimer)
        }
      },1000)
    },
    getCode() {
      this.postData.code_rand = new Date().getTime()
      this.codeImg = this.ApiUrl+'/api/Account/code?code_rand='+this.postData.code_rand
    },
    getMailCode() {
      if(!this.$store.state.UserInfo.mail){
        this.$Dialog.Alert(this.$t('UserInfo[1][1]'),()=>{
          this.$router.push('/user/set/mail')
        })
        return
      }
      this.isSendCode = true
      this.countDown()
      this.$Model.GetMailCode({mail: this.$store.state.UserInfo.mail, code: '', code_rand: '',type: 'fund_password'},(data)=>{
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
    getSmsCode() {
      if(!this.$store.state.UserInfo.phone){
        this.$Dialog.Alert(this.$t('UserInfo[1][0]'),()=>{
          this.$router.push('/user/set/phone')
        })
        return
      }
      this.isSendCode = true
      this.countDown()
      this.$Model.GetSMSCode({phone: this.$store.state.UserInfo.phone,dest: this.$store.state.UserInfo.dest,code: '', code_rand: '',type: 'fund_password'},(data)=>{
        this.isSendCode = false
        if(data.code!=1){
          // this.getCode()
        }else{
          this.$Dialog.Alert(data.code_dec)
        }
      })
    },
    changePush(val) {
      localStorage['PushState'] = val?'':1
      if(val){
        this.$parent.$parent.lockReconnect = false
        this.$parent.$parent.creationPush()
      }else{
        this.$parent.$parent.lockReconnect = true
        this.$parent.$parent.socketWeb&&this.$parent.$parent.socketWeb.close()
      }
    },
    selectHeader(index) {
      this.radioHeader = `head_${index}.png`
      setTimeout(()=>{
        this.$refs.setHeader.submit()
      },500)
      // this.$refs.setHeader.submit()
    },
    setUserInfo(json) {
      this.$Model.SetUserInfo(json,data=>{
        if(data.code==1){
          if(this.showHeader){
            this.showHeader = false
          }
          if(this.showPassWord){
            this.showPassWord = false
          }
          if(this.showPayWord){
            this.showPayWord = false
            this.forgetPayword = false
          }
          this.postData = {}
        }
      })
    },
    clearCache() {
      localStorage.clear()
      this.$Model.GetBackData()
      this.$router.push('/login')
      if(window.plus){
        plus.runtime.restart()
      }
    },
  }
}
</script>
<style scoped>
.van-cell__left-icon{
  font-size: 22px;
  margin-right: 10px;
}
</style>